<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div>
          <b-list-group>
            <b-list-group-item
                v-for="activity in items"
                :key="activity.id"
                class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-4"
            >

              <AssessmentActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Assessment\\Models\\Assessment'"/>
              <QuestionActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Assessment\\Models\\Question'"/>

            </b-list-group-item>

          </b-list-group>
          <hr class="mt-0"/>
        </div>
        <InfiniteLoading @infinite="loadingHandler">
          <template slot="no-results">
            <span>
              No data available.
            </span>
          </template>
        </InfiniteLoading>
      </div>
    </div>
  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import AssessmentActivity from '@/components/activity/assessment/Assessment.vue';
  import QuestionActivity from '@/components/activity/assessment/Question.vue';

  import InfiniteLoading from 'vue-infinite-loading';

  export default {
    name: 'AssessmentHistory',
    data: function() {
      return {
        assessment: {},
        items: [],
        currentPage: 1,
        totalRows: 0,
        page: 1
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      }
    },
    components: {
      AssessmentActivity,
      InfiniteLoading,
      QuestionActivity
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      }
    },
    methods: {
      loadingHandler($state) {
        let self = this
        piincHttp.get('activity-log', { params:
          {
            log: this.assessment.who_am_i + '::' + this.assessment.id,
            page: this.page,
            client: self.getClient.slug
          }
        }).then(({ data }) => {
          if (data.items.length) {
            self.page += 1;
            self.items.push(...data.items);
            if ($state) {
              $state.loaded();
            }
          } else {
            if ($state) {
              $state.complete();
            }
          }
        });
      }
    },
    created () {
      this.assessment = this.object;
    }
  }
</script>
